<div class="container-input">
  <mat-label class="container-input__label" [ngStyle]="{'color': inputTextColor , 'border-color': borderColor}">{{ 'INPUTS.' + placeholder | translate }}</mat-label>
  <mat-form-field
    [hideRequiredMarker]="true"
    [ngStyle]="{'background-color': inputBackgroundColor}"
    appearance="outline">
    <input class="input"
      matInput
      [type]="type"
      [value]="value"
      (input)="onInput($event)"
      (blur)="onBlur()"
      [required]="required"
      [attr.minlength]="minLength"
      [attr.maxlength]="maxLength"
      [disabled]="disabled"
      [ngStyle]="{'color': inputTextColor}"
    />
    <button
      *ngIf="isPasswordField"
      mat-icon-button
      type="button"
      (click)="togglePasswordVisibility()"
      class="password-toggle"
      aria-label="Toggle password visibility"
      [ngStyle]="{'color': buttonColor}"
    >
      <mat-icon>{{ passwordIcon }}</mat-icon>
    </button>
    <mat-error *ngIf="required && !value">This field is required</mat-error>
    <mat-error *ngIf="minLength && value.length < minLength">
      Minimum {{ minLength }} characters required
    </mat-error>
    <mat-error *ngIf="maxLength && value.length > maxLength">
      Maximum {{ maxLength }} characters allowed
    </mat-error>
  </mat-form-field>
</div>